import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import {Vehicle} from '@app/interfaces';
import {Clipboard} from '@angular/cdk/clipboard';
import {NotificationService} from '@app/services/notification.service';
import {VehicleApiService} from '@app/services/api/vehicle-api.service';
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-share-ad-dialog',
    templateUrl: './share-ad-dialog.component.html',
    styleUrls: ['./share-ad-dialog.component.scss'],
    standalone: false
})
export class ShareAdDialogComponent implements OnInit, OnDestroy {

  public vehicle: Vehicle;
  private destroy$ = new Subject<void>();
  public publicAdUrl?: string;
  public linkUnavailable = false;
  public websiteNotLive = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private clipboard: Clipboard,
              private notificationService: NotificationService,
              private vehicleApi: VehicleApiService,
              public dialogRef: MatDialogRef<unknown>,
  ) {

    this.vehicle = data.vehicle;
  }

  static open(dialog: MatDialog, vehicle: Vehicle) {
    return dialog.open(ShareAdDialogComponent, {
      width: '600px',
            disableClose: true,
      data: {
        vehicle,
      }
    });
  }

  ngOnInit() {
    this.vehicleApi.getPublicLinkForVehicle(this.vehicle.vehicleUuid)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          // BRIEFD-7429 (item 11): a vehicle live on Njuškalo but on an account
          // without the Website module has no `url`, and the dialog used to claim
          // it wasn't published anywhere. `bestUrl` is the backend's whole answer.
          //
          // Deliberately NOT `?? result.data.url` (QA round 3): plain `url` is
          // raw getVehiclePublicLink(), which checks module access and a
          // configured domain but NOT whether the vehicle is published, while
          // bestUrl requires is_published AND a published_vehicles row. Falling
          // back re-published a storefront URL for a vehicle the storefront does
          // not list, and left this dialog disagreeing with the printout QR
          // code, which reads bestUrl alone.
          const url = result.data.bestUrl;
          if (url) {
            this.publicAdUrl = url;
          } else {
            this.linkUnavailable = true;
            this.websiteNotLive = !!result.data.websiteNotLive;
          }
        },
        error: () => {
          this.notificationService.showErrorAlert();
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  close() {
    this.dialogRef.close(false);
  }

  selectText(event) {
    event.target.setSelectionRange(0, this.publicAdUrl?.length ?? 0);
  }

  copyToClipboard() {
    if (!this.publicAdUrl) {
      this.notificationService.showErrorAlert();
      return;
    }
    this.clipboard.copy(this.publicAdUrl);
    const successMessage = (() => $localize`:@@notification.copy-to-clipboard-success:Tekst je bil uspešno skopiran`)();
    this.notificationService.showInfoAlert(successMessage);
  }
}
